import { environment } from 'src/environments/environment'
export class EndPoints {

  // Authentication
  public static readonly LOGIN = 'portal/accounts/login/';
  public static readonly CURRENT_USER = 'portal/accounts/me/';

  public static readonly UPDATE = 'api/users/update';
  public static readonly USER_TYPES = '/api/user-types';
  public static readonly USER_ACCESS_TYPES = 'api/users/access-types';

  // Kwikspace
  public static readonly QUOTES = 'store/quotes/';
  public static readonly CUSTOMER_QUOTES = 'store/customer-quotes/';
  public static readonly SALES_QUOTES = 'store/sales-quotes/';
  public static readonly CUSTOMERS = 'account/customers/';
  public static readonly SALES_REPS = 'account/salesrep/';
  public static readonly VALIDITY = 'store/validfor/';
  public static readonly RENTAL_PRICING = 'store/rentals/';
  public static readonly RENTAL_CATEGORY = 'store/category/';
  public static readonly RENTAL_CATEGORY_SIZE = 'store/rental-category-size/';
  public static readonly RENTAL_SIZES = 'store/rentalsize/';
  public static readonly RENTAL_PERIODS = 'store/rentalperiod/';
  public static readonly RENTAL_OPTIONS = 'store/rentalitem/';
  public static readonly RENTAL_LINE_ITEMS = 'store/lineitems/';

  public static readonly TRANSPORT_CHARGE_OPTIONS = 'store/transportoptions/';
  public static readonly TRANSPORT_LOADS = 'store/transportloads/';
  // public static readonly TRANSPORT_LOADS_PURCHASE = 'store/transportloadspurchase/';
  public static readonly TRANSPORT_CHARGE = 'store/transportation-configurations/';
  public static readonly TRANSPORT_CHARGE_DISCOUNTED = 'store/transportation-configurations-discounted/';
  public static readonly TRANSPORT_DISTRICTS = 'store/districts/';
  public static readonly TRANSPORT_AREAS = 'store/areas/';
  public static readonly PRODUCTS = 'store/products/';
  public static readonly PRODUCT_LIST = 'store/product-list/';
  public static readonly PRODUCT_CONFIG = 'store/productconfig/';

  public static readonly PURCHASE_LINE_ITEMS = 'store/purchaselineitems/';
  public static readonly ASSET_CONFIG = 'store/assetconfig/';
  public static readonly PURCHASE_SIZES = 'store/purchasesize/';
  public static readonly DRAWING_LAYOUT_DETAILS = 'store/drawing-layout-detail/'
  // public static readonly PURCHASE_PRODUCT_ASSET_PRICE_MATCH = 'store/assetpricing/'
  public static readonly PURCHASE_PRODUCT_ASSET_PRICE_MATCH = 'portal/store/project/products/pricing/'
  
  public static readonly FP_PROJECT_CATEGORIES = 'store/fp-project-category/'
  public static readonly FP_PROJECT_SUB_CATEGORIES = 'store/fp-project-subcategory/'
  public static readonly FP_PROJECT_SIZES = 'store/fp-project-size/'
  public static readonly FP_PROJECT_EXTRAS = 'store/fp-project-extras/'
  public static readonly FP_PROJECT_CATEGORY_SIZE = 'store/purchase-category-size/'
  public static readonly FP_PROJECT_PRICE_LIST = 'store/standard-purchase-price/'
  public static readonly FP_PROJECT_LIST = 'floorplanner/projects/'

  public static readonly ADDRESS = 'account/address/';
  public static readonly COMPANY = 'account/company/';
  public static readonly LOCATIONS = 'account/saleslocation/';

  public static readonly QUOTE = 'store/quotes/:id';
  public static readonly QUOTE_EMAIL = 'portal/store/email/rental-pdf/';
  public static readonly REPORT_EMAIL = 'portal/store/email/report/';
  public static readonly PURCHASE_QUOTE_EMAIL = 'portal/store/email/purchase-template-pdf/';

  public static readonly PROVINCES = 'store/provinces/';
  public static readonly BUILDINGS = 'store/buildings/';
  public static readonly ORGANIZATIONS = 'store/organizations/';
  public static readonly DOWNLOAD_QUOTE_RENTAL = 'portal/store/rental/pdf/';
  public static readonly EMAIL_QUOTE_RENTAL = 'portal/store/email/rental/pdf/';
  public static readonly DOWNLOAD_QUOTE_PURCHASE = 'portal/store/purchase/pdf/';
  
  // Reports
  public static readonly DOWNLOAD_RENTAL_SALES_REPORT = 'portal/store/weekly/sales/rental/';
  public static readonly EMAIL_RENTAL_SALES_REPORT = 'portal/store/email/weekly/sales/rental/';
  public static readonly DOWNLOAD_RENTAL_SALES_REPORT_DETAIL = 'portal/store/weekly/detail/rental/';
  public static readonly EMAIL_RENTAL_SALES_REPORT_DETAIL = 'portal/store/email/weekly/detail/rental/';

  // Floor Planner
  public static readonly FP_USER_KEY = 'floorplanner/user/';
  public static readonly FP_PROJECTS = 'floorplanner/projects/';
  public static readonly FP_PROJECT_DOWNLOAD = 'floorplanner/project/download/:id';
  public static readonly FP_PROJECT = 'floorplanner/project/new/';
  public static readonly FP_TEMPLATES = 'floorplanner/templates/';
  public static readonly FP_TEMPLATE = 'floorplanner/template/:id';
  public static readonly FP_PROJECT_EXPORT = 'floorplanner/exports/:id';
  public static readonly FP_EXPORT_FML = 'floorplanner/export/fml/:id';
  public static readonly FP_EXPORT_TWO = 'floorplanner/export/2d/:id';
  public static readonly FP_EXPORT_THREE = 'floorplanner/export/3d/:id';
  public static readonly FP_CREATE_DESIGN = 'floorplanner/project/:id/floors/:id/designs/';
  public static readonly FP_GET_DIAGRAM = 'floorplanner/project/:id/floors/:id/designs/:id/';
  public static readonly FP_GET_PRODUCTS = 'floorplanner/projects/:id/products/';
  public static readonly FP_SAVE_PROJECT_PRODUCTS = 'floorplanner/project/:id/products/';

  // Floor Planner API Endpoints
  // public static readonly FLOORPLANNER_PROJECTS = `${environment.floorplanner.apiUrl}projects.json`;
  // public static readonly FLOORPLANNER_TOKEN = `${environment.floorplanner.apiUrl}users/token.json`;
  // public static readonly FLOORPLANNER_DESIGN = `${environment.floorplanner.apiUrl}designs.json`;

}

export class AppRoutes {
  public static readonly LOGIN = 'login';
  public static readonly REGISTER = 'portal/accounts/register/user/';
  public static readonly FORGOT_PASSWORD = 'accounts/password_reset/';

  public static readonly DASHBOARD = 'pwa/dashboard';
  public static readonly PWA = 'pwa/';
  public static readonly REPORT = 'report';

  public static readonly QUOTE_LIST = 'quotes';
  public static readonly CUSTOMER_LIST = 'customers';
  public static readonly CUSTOMER_DETAILS = 'customer';
  public static readonly ORDER_LIST = 'orders';
  public static readonly PRODUCT_LIST = 'products';
  public static readonly TRANSPORT_CHARGE_LIST = 'transportations';
  public static readonly RENTAL_PRICING_LIST = 'rentals';

  public static readonly VIEW_QUOTE = 'quotes/:id';
  public static readonly VIEW_CUSTOMER = 'customers/:id';
  public static readonly NEW_RENTAL_QUOTE = 'quotes/new/rental';
  public static readonly EDIT_RENTAL_QUOTE = 'quotes/edit/rental/:id';
  public static readonly EDIT_PURCHASE_QUOTE = 'quotes/edit/purchase/:id';
  public static readonly NEW_PURCHASE_QUOTE = 'quotes/new/purchase';
  public static readonly NEW_CUSTOMER = 'customer/new';

}
